//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: ['shippingMethods', 'currency'],
  data() {
    return {
      selectedMethod: this.shippingMethods[0].id,
      showPacketa: false,
      packetaChoosed: false,
    };
  },
  methods: {
    calculateTotal(selectedMethod) {
      fetch('/?wc-ajax=calculatetotalprice', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams({
          shipping_method: selectedMethod,
          currency: this.currency,
        }),
      })
        .then(response => response.json())
        .then(price => {
          const currencyCode = this.currency == 'czk' ? 'Kč' : '€';
          const formatedPrice = parseFloat(price)
            .toFixed(1)
            .replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
            .replace('.0', '');
          $('#totalPrice').html(`${formatedPrice} ${currencyCode}`);
        });
    },
  },
  watch: {
    selectedMethod(value) {
      this.calculateTotal(value);
    },
    currency() {
      this.calculateTotal(this.selectedMethod);
    },
  },
  mounted() {
    const vm = this;
    this.calculateTotal(this.selectedMethod);
    $(document.body).on(
      'wpify_woo_packeta_point_selected, wpify_woo_packeta_point_details_added',
      function() {
        vm.showPacketa = true;
        vm.packetaChoosed = true;
      }
    );
  },
};



// WEBPACK FOOTER //
// ./scripts/vue/checkout/ShippingMethods.vue